import { useAtomValue } from 'jotai';

import * as state from '../_state/officeEditor.state';
import { useTranslations } from '../i18n/useTranslations';

import { OfficeEditor } from './OfficeEditor';

export const OfficeEditorView = () => {
  const t = useTranslations();
  const fileId = useAtomValue(state.$fileId);

  if (!fileId) {
    return <div>{t.office.editor.noFileId}</div>;
  }

  return (
    <OfficeEditor className="@OfficeEditorView size-full" fileId={fileId} />
  );
};
